import styled from '@emotion/styled'
import { Steps } from 'antd'
import { useFormikContext } from 'formik'
import type { WizardFormValues } from '@sportninja/common/features/competition/wizard'
import colors from '@sportninja/common/constants/appColors'
import { useWizardNavigation } from './WizardContext'
import { getCurrentStepIndex, getWizardSteps } from './utils/getWizardSteps'

const WizardStepsHeader = () => {
  const { state } = useWizardNavigation()
  const { values } = useFormikContext<WizardFormValues>()
  const steps = getWizardSteps(values, state.currentStep)
  const current = getCurrentStepIndex(steps, state.currentStep)

  return (
    <Container>
      <Steps
        current={current}
        items={steps.map((s) => ({
          title: s.title,
          description: s.description,
        }))}
        size='small'
      />
    </Container>
  )
}

export default WizardStepsHeader

// ---- styled ----
const Container = styled.div`
  padding: 16px 24px;

  /* 20% larger step circles (24 -> 29px) and 20% larger label font */
  .ant-steps-item-icon {
    width: 32px !important;
    height: 32px !important;
    font-size: 14px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .ant-steps-item-icon .ant-steps-icon {
    font-size: 14px !important;
    line-height: 1 !important;
    top: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .ant-steps-item-icon .ant-steps-icon .anticon {
    font-size: 14px !important;
    line-height: 1 !important;
  }

  /* Past (finished) steps: SECONDARY_300 background */
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: ${colors.SECONDARY_300} !important;
    border-color: ${colors.SECONDARY_300} !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
    color: ${colors.PRIMARY} !important;
  }

  /* Step title and description font sizes */
  .ant-steps-item-title {
    font-size: 16px !important;
    line-height: 22px !important;
  }
  .ant-steps-item-description {
    font-size: 12px !important;
    line-height: 18px !important;
    padding-top: 2px !important;
  }

  /* Connector line between steps */
  .ant-steps-item-title::after {
    height: 2px !important;
    background-color: ${colors.SECONDARY_200} !important;
  }
  /* Finished steps keep the active (primary) color on their trailing line */
  .ant-steps-item-finish
    > .ant-steps-item-container
    .ant-steps-item-title::after {
    background-color: ${colors.PRIMARY} !important;
  }
`
